import {conversationOnlySubmission} from '@shared/chatSubmissionIntent';
interface TaskChatTitleInput {
  taskId: number;
  initialName: string;
  message: string;
  productName?: string;
  onUpdated?: () => void;
}

/** Best effort naming; the server compares names atomically to preserve user renames. */
export async function generateTaskChatTitle(
  { taskId, initialName, message, productName, onUpdated }: TaskChatTitleInput,
  fetcher: typeof fetch = fetch,
): Promise<void> {
  const fallback = message.length > 40 ? message.slice(0, 40) + '…' : message;
  if(conversationOnlySubmission(message))return;
  if (!message.trim() || (initialName !== fallback && !/^(new task|new chat|untitled)$/i.test(initialName))) return;
  try {
    const response = await fetcher('/api/canvas/generate-title', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, ...(productName ? { productName } : {}) }),
    });
    if (!response.ok) return;
    const { title } = await response.json();
    if (typeof title !== 'string' || !title.trim() || title.length > 80 || /[\r\n]/.test(title)) return;
    const patched = await fetcher(`/api/canvas/tasks/${taskId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: title.trim(), expectedName: initialName }),
    });
    if (patched.ok) onUpdated?.();
  } catch { /* Keep the initial name; title generation must never block the chat. */ }
}
